/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qr_Navigate_SubmitInputs */

const vi_qr_navigate_submit = /** @type {(inputs: Qr_Navigate_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xem đơn`)
};

/**

* @param {Qr_Navigate_SubmitInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const qr_navigate_submit = /** @type {((inputs?: Qr_Navigate_SubmitInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qr_Navigate_SubmitInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_qr_navigate_submit(inputs)
});